// import axios from 'axios';
// const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

// export const STATUSES = Object.freeze({
//     IDLE: 'idle',
//     ERROR: 'error',
//     LOADING: 'loading',
// });

// const getCard = createSlice({
//     name: 'Card',
//     initialState: {
//         data: [],
//         status: STATUSES.IDLE,
//     },
 
//     extraReducers: (builder) => {
//         builder
//             .addCase(fetchRace.pending, (state, action) => {
//                 state.status = STATUSES.LOADING;
//             })
//             .addCase(fetchRace.fulfilled, (state, action) => {
//                 state.data = action.payload;
//                 state.status = STATUSES.IDLE;
//             })
//             .addCase(fetchRace.rejected, (state, action) => {
//                 state.status = STATUSES.ERROR;
//             });
//     },
// });

// export const { setRace, setStatus } = getCard.actions;
// export default getCard.reducer;

// export const fetchRace = createAsyncThunk('RaceCardOfToday/fetch', async ({ calenderid, convertedDate}) => {
//     const res = await axios.get(`${getBaseUrl()}/RaceCardEveryday/${calenderid}/${convertedDate} `)
//     const data =  res.data;
//     return data.data;
// });



import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Cookies from "js-cookie";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
  IDLE: 'idle',
  ERROR: 'error',
  LOADING: 'loading',
});

// Async thunk to fetch race card data
export const fetchRace = createAsyncThunk(
  'RaceCardOfToday/fetch',
  async ({ calenderid, convertedDate }, thunkAPI) => {
    try {
      const token = Cookies.get("token");
      const baseUrl = getBaseUrl().replace(/\/+$/, "");
      const headers = {};
      if (token && token !== "undefined") {
          headers.Authorization = token;
          headers["x-xsrf-token"] = token;
      }
      const url = `${baseUrl}/RaceCardEveryday/${calenderid}/${convertedDate}`;
      const res = await axios.get(url, { headers });
      return res.data.data;
    } catch (err) {
      console.error("❌ fetchRace error:", err);
      return thunkAPI.rejectWithValue(err.response?.data || "Fetch error");
    }
  }
);

// Redux slice for race card
const getCard = createSlice({
  name: 'Card',
  initialState: {
    data: [],
    status: STATUSES.IDLE,
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchRace.pending, (state) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(fetchRace.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(fetchRace.rejected, (state) => {
        state.status = STATUSES.ERROR;
      });
  },
});

export default getCard.reducer;
